import React from 'react';
import { useTranslation } from 'react-i18next';
import ReceiptItem from 'components/common/receipt/receipt_item';
import { toPercentageString, taxGroupingByLabel } from 'utilities/tax';

const CaTaxReceiptItem = ({ orderData, taxType }) => {
  const { t } = useTranslation();

  const taxes = orderData.tax_breakdown.filter(
    (t) => !taxType || (taxType && t.type === taxType),
  );

  if (taxes.length === 0) {
    return null;
  }

  return (
    <>
      {Object.values(taxGroupingByLabel(taxes)).map((b) => (
        <ReceiptItem
          key={b.label}
          label={t(`ca.tax.jurisdiction.${b.label}`, {
            tax_rate: toPercentageString(b.tax_rate),
          })}
          cost={b.amount}
          currency={b.currency}
          isTax={true}
        />
      ))}
    </>
  );
};

export default CaTaxReceiptItem;
